export function getTimeUnitInterval(value) {
  if (value === '0' || value === '1' || !value || value === 'today' || value === '24h') {
    return 'day'
  }
  if (value === '3') {
    return 'week'
  }
  if (value === '12' || value === '6' || value === '24' || value === '36' || value === '61') {
    return 'month'
  }
  return 'week'
}
